import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Spin } from 'antd';
import type { BtlApplication } from 'api/btlApplicationForm/types';
import { CaseSidebarItemId } from 'components/CaseSidebar/types';
import { BtlBaseForm } from 'pages/BtlApplicationFormPage/BtlBaseForm';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { useOoCaseApplicantIndividualForm } from './useOoCaseApplicantIndividualForm';

interface CaseApplicantIndividualPageProps {
  case?: BtlApplication;
  isCaseLoading: boolean;
  individualId: string;
}

export function CaseApplicantIndividualPage({
  case: caseData,
  isCaseLoading,
  individualId,
}: CaseApplicantIndividualPageProps) {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  const form = useOoCaseApplicantIndividualForm({ caseData, individualId, isCaseLoading });

  const handleBack = () => {
    navigate({ search: `?section=${CaseSidebarItemId.APPLICANTS}` });
  };

  if (form.isLoading) {
    return <Spin size='large' />;
  }

  const individual = caseData?.borrower.individuals.find(item => item.id === individualId);

  return (
    <div className='flex flex-col gap-4'>
      <Button type='link' className='w-fit px-0' icon={<ArrowLeftOutlined />} onClick={handleBack}>
        {formatMessage({ id: 'btlApplicationForm.APPLICANTS.label' })}
      </Button>
      {individual && (
        <h3 className='m-0'>
          {individual.title} {individual.firstName} {individual.lastName}
        </h3>
      )}
      <BtlBaseForm {...form.formProps} />
    </div>
  );
}
